import React from "react";
import { connect } from "react-redux";

import TextChart from "../../../Charts/TextChart";

const TextoPedidosPendientes = (props) => {
  const {
    cantidad,
    loading,
    error,
  } = props;

  const chartSinDatos = error;

  return (
    <TextChart
      title={`Cantidad de pedidos pendientes`}
      bigAmount={`${cantidad}`}
      loading={loading}
      imgSinDatos={error || chartSinDatos}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.ventas.pedidosPendientes.loading,
    error: state.ventas.pedidosPendientes.error,
    cantidad: state.ventas.pedidosPendientes.cantidad,
    total: state.ventas.pedidosPendientes.total,
  };
};

const mapDispatchToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(TextoPedidosPendientes);
